import MarketSnapshotsBaseRoute from 'lumen/routes/market/snapshots/base';
import { SNAPSHOT_VIEW_CONFIG } from 'lumen/utils/constants/market-snapshots-constants';
import protectedRoute from 'lumen/utils/decorators/protected-route';

@protectedRoute({
  features: [SNAPSHOT_VIEW_CONFIG.pickup.feature],
})
export default class MarketSnapshotsPickupRoute extends MarketSnapshotsBaseRoute {
  readonly config = SNAPSHOT_VIEW_CONFIG.pickup;
}
